<template>
  <div class="mapCont">
    <div id="mapSelf" :style="`width: ${pageWidth}px; height: 780px`"  v-if="mapShow"></div>
    <div id="mapSelfChina" :style="`width: ${pageWidth}px; height: 780px`" v-else></div>
  </div>
</template>

<script>
import mapData from "@/utils/yhq.json";
import chinaMapData from "@/utils/chinaMapData.json";
export default {
  props: {
    parkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mapShow: false,
      pageWidth: window.innerWidth - 100
    }
  },
  mounted() {
    this.pageWidth = window.innerWidth - 100
  },
  methods: {
    getMapChina(parkList) {
      let geoCoordMap = {};
      let allNumber = [];
      parkList.forEach((element) => {
        geoCoordMap[element.enterpriseName] = [element.lat, element.lng];
        allNumber.push({
          logo: element.logoUrl,
          name: element.enterpriseName,
          details: element.details,
          jwd: [element.lat, element.lng],
          value: 0,
        });
      });
      let convertData = (data) => {
        let res = [];
        for (let i = 0; i < data.length; i++) {
          let geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              logo: data[i].logo,
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
              jwd: geoCoord.concat(data[i].jwd),
              details: data[i].details,
            });
          }
        }
        return res;
      };
      //因为我在main.js全局引入了，所以用----------this.$echarts
      //如果只在当前页面用，就用上面的import------- $echarts
      let nameP = 'yh'
      this.$echarts.registerMap(nameP, mapData);
      let chart = this.$echarts.init(document.getElementById("mapSelf"));
      chart.setOption({
        tooltip: {
          show: false,
          trigger: "item",
          extraCssText: 'max-width:300px; white-space:pre-wrap',
          formatter: (params) => {
              return `${params.name}`;
            },
        },
        geo: {
          //必须要，标点就是根据这个
          map: nameP,
          roam: true,
          aspectScale: 0.8, //参数用于 scale 地图的长宽比。
          layoutCenter: ['50%', '50%'], //地图位置
          layoutSize: '100%', //地图的大小
          zoom: 1.1,
          tooltip: {
            show: true,
            // 将 tooltip 框限制在图表的区域内
            confine: true,
            trigger: "item",
            triggerOn: "mousemove",
            backgroundColor: "rgba(255, 255, 255, 0)",
            borderWidth: 0,
            padding: 0,
            extraCssText: 'max-width:300px; white-space:pre-wrap',
            formatter: (params) => {
              // console.log(333, params);
              // 可在JS文件单独引入CSS文件(import 'xx.css';)，这里把CSS文件里定义的样式复制到style
              let html = `<div class="custom-tooltip-box" style="max-width: 300px;font-size: 14px;padding: 15px 20px;box-sizing: border-box;background: rgb(255, 255, 255);border-radius: 15px">`;
              html += `<div style=" display: flex; align-items: center;margin-bottom: 10px">`;
              html += `<img class="logo" src="${params.data?params.data.logo: ''}" style="width:50px; height: 50px;border-radius:50%;margin-right: 10px;"></img>`;
              html += `<div class="title" style="font-size: 20px;color: #000;font-size: 14px">${params.data?params.data.name: ''}</div>`;
              html += `</div>`;
              html += `<div class="title" style="font-size: 20px;color: #000;font-size: 14px; width: 240px;display: -webkit-box;
                  overflow: hidden;
                  white-space: normal !important;
                  text-overflow: ellipsis;
                  word-wrap: break-word;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;">${params.data?params.data.details: ''}</div>`;
              html += `</div>`;
              return html;
            },
          },
        },
        series: [
          {
            type: "map",
            map: nameP,
            roam: true,
            selectedMode: false,
            zoom: 1.1,
            aspectScale: 0.8, //参数用于 scale 地图的长宽比。
            layoutCenter: ['50%', '50%'], //地图位置
            layoutSize: '100%', //地图的大小
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#323c48", //文字颜色
                  fontSize: 12,
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "#555", //鼠标hover文字颜色
                  fontSize: 12,
                },
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#f8f8f8", //整个背景填充颜色
                borderColor: "#555", //边界颜色
              },
              emphasis: {
                areaColor: "#d7eaea", //鼠标hover颜色，区域选中颜色
              },
            },
          },
          {
            type: "effectScatter", //影响散点
            coordinateSystem: "geo",
            showEffectOn: "render",
            zlevel: 2,
            rippleEffect: {
                period: 8, //动画时间，值越小速度越快
                brushType: 'stroke', //波纹绘制方式 stroke, fill
                scale: 5, //波纹圆环最大限制，值越大波纹越大
            },
            // 发散点的大小
            symbolSize: 5,
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "#2d50a1",
                shadowBlur: 10,
                shadowColor: "#2d50a1", //闪烁圈的颜色
              },
            },
            data: convertData(allNumber),
          },
        ],
      },true);
      let that = this
      // 点击每个市所获取到的值，这里可进行相关操作
      chart.on("click", (params) => {
        // console.log(1111, params)
      });
      //echarts 设置地图外边框以及多个geo实现缩放拖曳同步
      chart.on('georoam', function(params) {
          let option = chart.getOption(); //获得option对象
          if (params.zoom != null && params.zoom != undefined) { //捕捉到缩放时
            option.geo[0].zoom = option.series[0].zoom; //下层geo的缩放等级跟着上层的geo一起改变
            option.geo[0].center = option.series[0].center; //下层的geo的中心位置随着上层geo一起改变
          } else { //捕捉到拖曳时
            option.geo[0].center = option.series[0].center; //下层的geo的中心位置随着上层geo一起改变
          }
        // console.log(333, option.geo[0].zoom)
          if( option.geo[0].zoom < 0.4) {
            // console.log("变为大地图")
            chart.clear()
            that.mapShow = false
            setTimeout(()=> {
              that.getMap(parkList)
            }, 300)
            return
          }
          // 重新加载地图数据
          chart.setOption(option,true); //设置option
      });
      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    getMap(parkList) {
      // console.log("大地图")
      let geoCoordMap = {};
      let allNumber = [];
      parkList.forEach((element) => {
        geoCoordMap[element.enterpriseName] = [element.lat, element.lng];
        allNumber.push({
          logo: element.logoUrl,
          name: element.enterpriseName,
          details: element.details,
          jwd: [element.lat, element.lng],
          value: 0,
        });
      });
      let convertData = (data) => {
        let res = [];
        for (let i = 0; i < data.length; i++) {
          let geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              logo: data[i].logo,
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
              jwd: geoCoord.concat(data[i].jwd),
              details: data[i].details,
            });
          }
        }
        return res;
      };
      //因为我在main.js全局引入了，所以用----------this.$echarts
      //如果只在当前页面用，就用上面的import------- $echarts
      let nameP = 'china'
      // this.$echarts.registerMap(nameP, chinaMapData);
      let chartChina = this.$echarts.init(document.getElementById("mapSelfChina"));
      chartChina.setOption({
        goDown: true, // 是否下钻
        callback: function (name, option, instance) {
          console.log(name, option, instance);
        },
        tooltip: {
          show: false,
          trigger: "item",
          extraCssText: 'max-width:300px; white-space:pre-wrap',
          formatter: (params) => {
              return `${params.name}`;
            },
        },
        geo: {
          //必须要，标点就是根据这个
          map: "china",
          roam: true,
          aspectScale: 0.8, //参数用于 scale 地图的长宽比。
          layoutCenter: ['50%', '50%'], //地图位置
          layoutSize: '110%', //地图的大小
          zoom: 1.2,
          tooltip: {
            show: true,
            // 将 tooltip 框限制在图表的区域内
            confine: true,
            trigger: "item",
            triggerOn: "mousemove",
            backgroundColor: "rgba(255, 255, 255, 0)",
            borderWidth: 0,
            padding: 0,
            extraCssText: 'max-width:300px; white-space:pre-wrap',
            formatter: (params) => {
              // console.log(333, params);
              // 可在JS文件单独引入CSS文件(import 'xx.css';)，这里把CSS文件里定义的样式复制到style
              let html = `<div class="custom-tooltip-box" style="max-width: 300px;font-size: 14px;padding: 15px 20px;box-sizing: border-box;background: rgb(255, 255, 255);border-radius: 15px">`;
              html += `<div style=" display: flex; align-items: center;margin-bottom: 10px">`;
              html += `<img class="logo" src="${params.data?params.data.logo: ''}" style="width:50px; height: 50px;border-radius:50%;margin-right: 10px;"></img>`;
              html += `<div class="title" style="font-size: 20px;color: #000;font-size: 14px">${params.data?params.data.name: ''}</div>`;
              html += `</div>`;
              html += `<div class="title" style="font-size: 20px;color: #000;font-size: 14px; width: 240px;display: -webkit-box;
                  overflow: hidden;
                  white-space: normal !important;
                  text-overflow: ellipsis;
                  word-wrap: break-word;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;">${params.data?params.data.details: ''}</div>`;
              html += `</div>`;
              return html;
            },
          },
        },
        series: [
          {
            type: "map",
            map: nameP,
            roam: true,
            selectedMode: false,
            aspectScale: 0.8, //参数用于 scale 地图的长宽比。
            layoutCenter: ['50%', '50%'], //地图位置
            layoutSize: '110%', //地图的大小
            showLegendSymbol: false, // 存在legend时显示
            zoom: 1.2,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#323c48", //文字颜色
                  fontSize: 12,
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "#555", //鼠标hover文字颜色
                  fontSize: 12,
                },
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#f8f8f8", //整个背景填充颜色
                borderColor: "#555", //边界颜色
              },
              emphasis: {
                areaColor: "#d7eaea", //鼠标hover颜色，区域选中颜色
              },
            },
          },
          {
            type: "effectScatter", //影响散点
            coordinateSystem: "geo",
            showEffectOn: "render",
            zlevel: 2,
            // 涟漪效果
            rippleEffect: {
                period: 8, //动画时间，值越小速度越快
                brushType: 'stroke', //波纹绘制方式 stroke, fill
                scale: 5, //波纹圆环最大限制，值越大波纹越大
            },
            encode: {
              value: 10,
            },
            // 发散点的大小
            symbolSize: 5,
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "#2d50a1",
                shadowBlur: 10,
                shadowColor: "#2d50a1", //闪烁圈的颜色
              },
            },
            data: convertData(allNumber),
          },
        ],
      },true);
      let that = this
      // 点击每个市所获取到的值，这里可进行相关操作
      chartChina.on("click", (params) => {
        console.log("山西", params)
        if(params.name=="山西") {
          chartChina.clear()
          that.mapShow = true
          setTimeout(()=> {
            that.getMapChina(parkList)
          }, 300)
          return
        }
      });
      //echarts 设置地图外边框以及多个geo实现缩放拖曳同步
      chartChina.on('georoam', function(params) {
          let option = chartChina.getOption(); //获得option对象
          if (params.zoom != null && params.zoom != undefined) { //捕捉到缩放时
            option.geo[0].zoom = option.series[0].zoom; //下层geo的缩放等级跟着上层的geo一起改变
            option.geo[0].center = option.series[0].center; //下层的geo的中心位置随着上层geo一起改变
          } else { //捕捉到拖曳时
            option.geo[0].center = option.series[0].center; //下层的geo的中心位置随着上层geo一起改变
          }
          chartChina.setOption(option,true); //设置option
      });
      window.addEventListener("resize", () => {
        chartChina.resize();
      });
    },
  },
};
</script>

<style scoped>
.mapCont {
  width: 100%;
  height: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/homeIndex/parkEnterprise.vue